import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        provider: false,
        hardware: false,
        device: false,
    },
    getters: {
        provider: state => {
            return state.provider;
        },
        hardware: state => {
            return state.hardware;
        },
        device: state => {
            return state.device;
        },
    },
    mutations: {
        reset(state) {
            state.provider = false;
            state.hardware = false;
            state.device = false;
        },
        updateProvider(state, value) {
            state.provider = value;
        },
        updateHardware(state, value) {
            state.hardware = value;
        },
        updateDevice(state, value) {
            state.device = value;
        },
    },
    actions: {

    },
    modules: {

    }
})
